import { useQuery } from "@apollo/client";
import { OrganizationMembersDocument } from "../../__generated__/graphql";

interface UseOrganizationMembersOptions {
  skip?: boolean;
}

export default function useOrganizationMembers(
  options?: UseOrganizationMembersOptions
) {
  const { data, loading, error } = useQuery(OrganizationMembersDocument, {
    skip: options?.skip,
  });

  return { data, loading, error };
}
